import { gql } from '@apollo/client';

export const DELETE_KANBAN_LABEL = gql`
    mutation DeleteKanbanLabel($id: String!) {
        deleteKanbanLabel(id: $id) {
            id
        }
    }
`;
